import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";
import { baseURL } from "../../services/axios/eps";

const ProviderDetailsModal = ({
  selectedProvider,
  setSelectedProvider,
  openDetailsModal,
  setOpenDetailsModal,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedProvider(null);
    setOpenDetailsModal(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Game Provider</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <div className="d-flex justify-content-center">
          {selectedProvider?.logo && (
            <img
              crossorigin="anonymous"
              src={`${baseURL}/uploads/file/${selectedProvider.logo}`}
              alt="Logo"
              className="img-fluid rounded center"
              style={{ maxHeight: "200px", objectFit: "contain" }}
            />
          )}
        </div>
        <Row className="mb-3">
          <Col xs={12} md={12} lg={12} className="mb-3 mt-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">Name</span>
              <span className="d-block fs-5 fw-medium">
                {selectedProvider?.name || ""}
              </span>
            </div>
          </Col>
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">Website</span>
              <a
                href={selectedProvider?.website}
                target="_blank"
                className="d-block fs-5 fw-medium"
              >
                {selectedProvider?.website || ""}
              </a>
            </div>
          </Col>
          {Object.entries({
            "Email Address": selectedProvider?.contact_email || "",
            "Phone Number": selectedProvider?.phone || "",
            Status: selectedProvider?.status ? "Active" : "In-Active",
            "Created At": selectedProvider?.createdAt
              ? format(selectedProvider?.createdAt, "PP")
              : "",
            "Updated At": selectedProvider?.updatedAt
              ? format(selectedProvider?.updatedAt, "PP")
              : "",
            "Deleted At": selectedProvider?.deletedAt
              ? format(selectedProvider?.deletedAt, "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ProviderDetailsModal;
